module.exports = __webpack_public_path__ + "static/media/Suzuki-kiegeszito-default.9513d790.jpg";